import React from "react";
import {Aggregation, AggregationGroup} from "../../SearchResult";
import FacetGroup from "./FacetGroup";
import Facet from "./Facet";

interface TagFacetsProps {
    aggs: AggregationGroup<"tags">;
    activeAggregations: Set<string>;
}

export default function TagFacets({aggs, activeAggregations}: TagFacetsProps) {
    return (
        <FacetGroup title="Tags">
            {aggs.aggregations.map(({facet, count}: Aggregation) => (
                <Facet
                    key={facet}
                    type="tags"
                    facet={facet}
                    count={count}
                    isActive={activeAggregations.has(facet)}
                />
            ))}
        </FacetGroup>
    );
}
